import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router.js'
import i18n from './i18n.js'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
// Correzioni globali sopra gli stili di Vuetify (es. scrollbar sempre visibile del reset ress.css)
import './styles/app.css'
import '@mdi/font/css/materialdesignicons.css'
// Stile dei pulsanti derivato dal login: dopo gli stili di Vuetify, così a parità di specificità vince
import './styles/buttons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// import './style.css'
import App from './App.vue'

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)

const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)

app.mount('#app')
